export function sanitizeBlacklist(data, blacklist) {
  return Object.keys(data).reduce(
    (result, key) => (blacklist.includes(key)
      ? result
      : Object.assign(result, { [key]: data[key] })),
    {}
  );
}

export function sanitizeWhitelist(data, whitelist) {
  return whitelist.reduce(
    (result, key) => (data[key] !== undefined
      ? Object.assign(result, { [key]: data[key] })
      : result),
    {}
  );
}
